export default (configuration, item) => {
  try {
    // Sprawdzamy, czy configuration jest obiektem i czy ma właściwość config
    if (configuration && typeof configuration === 'object' && configuration.config) {
      // Sprawdzamy, czy configuration.config ma jakiekolwiek klucze
      if (Object.keys(configuration.config).length > 0) {
        return configuration.config[item];
      }
    }
  } catch (error) {
    console.error(`Error reading configuration for item ${item}:`, error);
  }
  
  return undefined;
};
